export const isEnv = (...env) => env.some(isEnvironment);

export const isDevelopmentEnvironment = () => isEnvironment('development');

export const isTestEnvironment = () => isEnvironment('test');

export const isEnvironment = (env) => process.env.NODE_ENV === env;
